module.exports = __webpack_public_path__ + "media/images/android-app-qrcode-a51d5ffbf36021b634c7ccf7e3d0ff9d.png";